const $ = jQuery.noConflict();

class Slider {
	constructor( selector, args = {} ) {
		this.selector = selector;
		this.args = args;
	}

	getDefaultSlickSettings() {
		return {
			dots: false,
			arrows: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			pauseOnHover: false,
			speed: 600,
		};
	}

	/**
	 * Override our default slick settings with args provided to the class.
	 */
	getSlickSettings() {
		return Object.assign( {}, this.getDefaultSlickSettings(), this.args );
	}

	init() {
		if ( ! $( this.selector ).not( '.slick-initialized' ).length ) {
			return;
		}
		const settings = this.getSlickSettings();
		$( this.selector ).slick( settings );
	}
}

const SimpleSlider = new Slider( '.gallery-slider__slider' );
const TestimonialSlider = new Slider( '.testimonial-slider', {
	centerMode: true,
	variableWidth: true,
	infinite: true,
	slidesToShow: 1,
} );

const FluidSlider = new Slider( '.gallery-slider__slider-fluid', {
	centerMode: true,
	variableWidth: true,
} );
const ProgramLinksSlider = new Slider( '.program-links__cards', {
	dots: true,
	arrows: false,
	variableWidth: true,
	touchThreshold: 100,
	infinite: true,
	swipeToSlide: true,
	mobileFirst: true,
	responsive: [ {
		breakpoint: 991,
		settings: 'unslick',
	} ],
} );
const ActivitySingleHeroSlider = new Slider( '.activity-hero__slider', {
	dots: false,
	arrows: true,
	variableWidth: true,
	touchThreshold: 100,
	swipeToSlide: true,
	loop: true,
	prevArrow: false,
	useTransform: false,
	easing: 'swing',
} );

export { SimpleSlider, TestimonialSlider, FluidSlider, ProgramLinksSlider, ActivitySingleHeroSlider };
